if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.setupNavigation();
        this.setupKeyboardNavigation();
      }

      setupNavigation() {
        const prevButton = this.querySelector('[data-modal-nav="prev"]');
        const nextButton = this.querySelector('[data-modal-nav="next"]');

        if (prevButton) {
          prevButton.addEventListener('click', () => this.navigateMedia(-1));
        }
        if (nextButton) {
          nextButton.addEventListener('click', () => this.navigateMedia(1));
        }
      }

      setupKeyboardNavigation() {
        this.addEventListener('keydown', (e) => {
          if (!this.open) return;

          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateMedia(-1);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateMedia(1);
          }
        });
      }

      navigateMedia(direction) {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        const activeMedia = this.querySelector('[data-media-id].active');

        if (!activeMedia || allMedia.length <= 1) return;

        const currentIndex = allMedia.indexOf(activeMedia);
        let nextIndex = currentIndex + direction;

        // Loop around
        if (nextIndex < 0) nextIndex = allMedia.length - 1;
        if (nextIndex >= allMedia.length) nextIndex = 0;

        const nextMedia = allMedia[nextIndex];

        // Update active state
        activeMedia.classList.remove('active');
        nextMedia.classList.add('active');

        // Load content if it's a deferred media
        const nextMediaTemplate = nextMedia.querySelector('template');
        const nextMediaContent = nextMediaTemplate ? nextMediaTemplate.content : null;

        if (
          nextMedia.nodeName == 'DEFERRED-MEDIA' &&
          nextMediaContent &&
          nextMediaContent.querySelector('.js-youtube')
        ) {
          nextMedia.loadContent();
        }

        // Scroll into view
        nextMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (nextMedia.width - container.clientWidth) / 2;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
